import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleLandlordPlan = _variables => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/plans/api/mutations/toggle_landlord_plan.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/plans/api/queries/get_all_landlord_plans.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ""
            }
          }
        };
        let allLandlordPlans = store.readQuery(query);
        store.writeQuery({
          ...query,
          data: allLandlordPlans,
          status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { toggleLandlordPlan };
